import apiClient from "../services/api";

const LAST_KEY = "v2r_last_presence_ping";
const MIN_INTERVAL_MS = 10 * 60 * 1000;

// Capture the phone's position (only while the app is open) and match it to geocoded jobsites.
// Resolves to [{id, name, distance_m}] or [] — never throws.
export const sendPresencePing = async (source = "app_open", force = false) => {
  if (!navigator.geolocation) return [];
  const last = Number(localStorage.getItem(LAST_KEY) || 0);
  if (!force && Date.now() - last < MIN_INTERVAL_MS) return [];
  const pos = await new Promise((resolve) =>
    navigator.geolocation.getCurrentPosition(resolve, () => resolve(null), {
      enableHighAccuracy: true, timeout: 10000, maximumAge: 5 * 60 * 1000,
    })
  );
  if (!pos) return [];
  localStorage.setItem(LAST_KEY, String(Date.now()));
  try {
    const res = await apiClient.post(`/presence/ping`, {
      lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy_m: pos.coords.accuracy, source,
    });
    return res.data?.matched_jobs || [];
  } catch {
    return [];
  }
};
